export default __webpack_public_path__ + "static/media/mountain_makovitsa_300.6903a7bc.webp";